import items from "./items"

export default {
    type: "array",
    items: items
}